/**
 * @desc 根据计划ID查询月计划概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanMonthOverviewResponse>>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanOverview',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<Array<defs.PlanMonthOverviewResponse>>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanOverview',
    data,
  });
}
